const getAppointmentBookingAlternativeUrlFormatter = (alternativeUrl) => {
  if (typeof alternativeUrl === "string") {
    try {
      const parsedObject = JSON.parse(alternativeUrl);
      if (typeof parsedObject === "object" && parsedObject !== null) {
        return parsedObject;
      }
    } catch {
      return alternativeUrl;
    }
  }
  return alternativeUrl;
};
export {
  getAppointmentBookingAlternativeUrlFormatter
};
//# sourceMappingURL=utils.js.map
